module.exports = __webpack_public_path__ + "static/media/RSA_Stamp.b327d2da.PNG";